import styled, { css } from 'styled-components'

import { ProductTileProps } from '@Components/Product/Tile'
import { WishlistButton } from '@Components/WishList/addToWishList'
import { up } from '@Globals/Style/breakpoints'
import { box, flexCenterChildren } from '@Globals/Style/mixins'

export const WishlistContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  right: 2px;
  top: 2px;
  width: 32px;
  height: 32px;
  padding: 9px 8px 7px 8px;
  z-index: 2;

  svg {
    width: 16px;
    height: 16px;
  }

  ${WishlistButton}.small {
    background: none;

    &:hover {
      background: rgba(255,255,255, .75);
    }
  }
`

export const InfoWrapper = styled.div<{ active?: boolean }>(({ active, theme }) => css`
  padding: 5px 0;
  transition: background-color 0.1s ease;
  ${active && css`
    padding-top: 11px;
    margin-top: -6px;
    border-bottom-left-radius: ${theme.borderRadius};
    border-bottom-right-radius: ${theme.borderRadius};
  `};

  ${up('phablet')} {
    padding-bottom: 7px;
  }
`)

export const ProductTileWrapper = styled.article`
  width: 100%;
  position: relative;
  font-size: 0.75rem;
  line-height: 1.2;

  * {
    font-size: inherit;
    line-height: inherit;
  }

  ${up('phablet')} {
    font-size: 0.8rem;
  }

  &:hover {
    ${InfoWrapper} {
      background-color: rgba(0, 0, 0, .02)
    }
  }
`

export const BrandAndPriceWrapper = styled.div(() => css`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-bottom: 3px;
  gap: 5px;
  align-items: center;

  > * {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  ${up('phablet')} {
    margin-bottom: 5px;
  }
`)

export const BrandWrapper = styled.div(({ theme }) => css`
  text-transform: uppercase;
  font-size: .65rem;
  color: ${theme.colors.grey};
`)

export const ProductTitle = styled.div<{ singleLine?: boolean }>(({ singleLine }) => css`
  line-height: 1.4;

  ${singleLine && css`
    overflow: hidden;
    white-space: nowrap;
  `}
`)

export const PriceWrapper = styled.div`
  flex: 1 0 auto;
  display: flex;
  justify-content: flex-end;
  gap: 5px;
`

export const BeforePrice = styled.span`
  font-weight: bold;
  text-decoration: line-through;
  display: block;
  margin-left: 3.5px;
`

export const Price = styled.span<Pick<ProductTileProps, 'beforePrice'>>(({ beforePrice, theme }) => css`
  font-weight: bold;
  ${beforePrice && css`
    color: ${theme.colors.red};
  `}
`)

export const OutOfStockWrapper = styled.div`
  ${flexCenterChildren};
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding-top: 100%;
  background-color: rgba(255, 255, 255, 0.45);
`

export const InnerWrapper = styled.div`
  ${box({ width: '100%' })}
  ${flexCenterChildren};
  position: absolute;
  top: 0;
  left: 0;
`
